import { render, staticRenderFns } from "./ReadSelectImage.vue?vue&type=template&id=1b87b0d5&scoped=true&"
import script from "./ReadSelectImage.vue?vue&type=script&lang=js&"
export * from "./ReadSelectImage.vue?vue&type=script&lang=js&"
import style0 from "./ReadSelectImage.vue?vue&type=style&index=0&id=1b87b0d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87b0d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b87b0d5')) {
      api.createRecord('1b87b0d5', component.options)
    } else {
      api.reload('1b87b0d5', component.options)
    }
    module.hot.accept("./ReadSelectImage.vue?vue&type=template&id=1b87b0d5&scoped=true&", function () {
      api.rerender('1b87b0d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ReadSelectImage.vue"
export default component.exports